export default function (...args) {
	let url = args.join('/');
	return url;
}